// src/bugsnag.tsx
import React from "react";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

// Type for the ErrorBoundary component
type ErrorBoundaryType = React.ComponentType<{ children?: React.ReactNode }>;

// Initialize Bugsnag with your API key
Bugsnag.start({
  apiKey: process.env.REACT_APP_BUGSNAG_KEY as string,
  plugins: [new BugsnagPluginReact()],
  enabledBreadcrumbTypes: ["error", "log", "navigation", "request", "user"],
  autoDetectErrors: true,
  releaseStage: process.env.REACT_APP_ENV,
  onError: function (event) {
    if (event.errors[0]?.errorMessage?.includes("Converting circular structure to JSON")) {
      return false;
    }
    event.addMetadata("server", {
      baseURL: process.env.REACT_APP_ENV,
    });
  },
});

// Bugsnag.notify(new Error("New error Foun   testing "));

// Get the ErrorBoundary component from Bugsnag's React plugin
const bugsnagReactPlugin = Bugsnag.getPlugin("react");
if (!bugsnagReactPlugin) {
  throw new Error("Bugsnag React plugin not found");
}

const ErrorBoundary: ErrorBoundaryType = bugsnagReactPlugin.createErrorBoundary(
  React
);

export default ErrorBoundary;
